/* eslint-disable @typescript-eslint/no-explicit-any,@typescript-eslint/no-unnecessary-condition */
import type { ITopicListItem } from '@newo/api/gateway';
import { IWorkflowStep, IFilters } from '@/pages/Workflow/Workflow.types.ts';

function binaryTreeToArray(
    root: any,
    hash: Record<string, any> = {}
): IWorkflowStep[][] {
    if (!root) return [];

    const result = [];
    const queue = [root];

    while (queue.length > 0) {
        const levelSize = queue.length;
        const currentLevel = [];

        for (let index = 0; index < levelSize; index += 1) {
            const node = queue.shift();
            currentLevel.push(node);

            if (hash[node.first]) queue.push(hash[node.first]);
            if (hash[node.second]) queue.push(hash[node.second]);
        }

        result.push(currentLevel);
    }

    return result;
}

export const buildChain = (
    tasks: ITopicListItem[],
    filters: IFilters
): IWorkflowStep[][] => {
    const grouped: Record<string, IWorkflowStep> = {};
    const chains: IWorkflowStep[][] = [];
    const mainInstructions: IWorkflowStep[] = [];
    for (const { topic: task } of tasks) {
        if (
            (filters.industry && !task.labels.includes(filters.industry)) ||
            (filters.labels.length > 0 &&
                !task.labels.some((l) => filters.labels.includes(l)))
        ) {
            continue;
        }
        if (task.topic_name === 'AGENT_MAIN_INSTRUCTION') {
            mainInstructions.push({
                name: task.topic_name,
                first: '',
                second: '',
                format: undefined,
                schema: {},
                instruction: task,
                context: [],
                industries: [],
                workflows: [],
                persona_id: task.persona_id
            });
        }
        if (!grouped[task.topic_name]) {
            grouped[task.topic_name] = {
                name: task.topic_name,
                first: '',
                second: '',
                format: undefined,
                schema: {},
                instruction: undefined,
                context: [],
                industries: [],
                workflows: [],
                persona_id: ''
            };
        }

        if (task.labels.includes('task_object_format')) {
            const schema = JSON.parse(task.topic_summary);
            const first = schema.receiver_task_idn;
            const second = schema.second_receiver_task_idn;
            grouped[task.topic_name] = {
                ...grouped[task.topic_name],
                format: task,
                schema,
                first: first === 'NO_TASK' ? undefined : first,
                second: second === 'NO_TASK' ? undefined : second,
                workflows: task.labels.filter((l) => l.includes('_workflow')),
                industries: task.labels.filter((l) => l.includes('_industry')),
                persona_id: task.persona_id
            };
        }

        if (task.labels.includes('task_instruction')) {
            grouped[task.topic_name].instruction = task;
            grouped[task.topic_name].persona_id = task.persona_id;
        }

        if (task.labels.includes('task_context')) {
            grouped[task.topic_name].context.push(task);
            grouped[task.topic_name].persona_id = task.persona_id;
        }
    }

    const steps = Object.values(grouped);
    const refs = new Set(steps.flatMap((step) => [step.first, step.second]));

    if (grouped.AGENT_MAIN_INSTRUCTION) {
        chains.push(mainInstructions);
    }

    for (const step of steps) {
        if (!refs.has(step.name) && step.name !== 'AGENT_MAIN_INSTRUCTION') {
            const array: IWorkflowStep[][] = binaryTreeToArray(step, grouped);
            let index = grouped.AGENT_MAIN_INSTRUCTION ? 1 : 0;

            while (array.length > 0) {
                const current = array.shift();
                if (current) {
                    if (index === chains.length) {
                        chains.push(current);
                    } else {
                        chains[index] = chains[index].concat(current);
                    }
                    index += 1;
                }
            }
        }
    }
    return chains;
};
